export default {
  back: {
    id: 'review_funnel_header_back',
    defaultMessage: 'Back',
  },
  skipStep: {
    id: 'review_funnel_header_skip_step',
    defaultMessage: 'Skip step',
  },
} as const
